export default __webpack_public_path__ + "static/media/looksrare-icon.0f2aace1.png";